import {
  Box,
  Flex,
  Text,
  Modal,
  ModalContent,
  ModalOverlay,
  Image,
  Button,
} from "@chakra-ui/react";
import React, { memo } from "react";
import IconRed from "../../../assets/images/booking/x-red.svg";
import IconX from "../../../assets/images/booking/x-circle.svg";
import IconCheck from "../../../assets/images/booking/check-circle.svg";
import toast from "react-hot-toast";
import { customerUpdateRequestCall } from "../../../api/customerUpdateRequest";
import ImagePreviewZoom from "../../../components/ImagePreviewZoom";

const baseURL = process.env.REACT_APP_BACKEND_API || "http://localhost:3001";

const FormInfo = memo(({ isOpen, onClose, value, refetch }) => {
  // console.log(value);
  const projectName = value?.wishlistDetail
    ? value?.wishlistDetail?.map((item) => item?.name).filter(Boolean)
    : null;

  const projectNameOld = value?.wishlistDetailOld
    ? value?.wishlistDetailOld?.map((item) => item?.name).filter(Boolean)
    : null;

  let permanentAddress = value?.permanentAddress || "";
  if (value?.permanentAddressWardData) {
    permanentAddress += ", ";
    permanentAddress += value.permanentAddressWardData?.name;
  }
  if (value?.permanentAddressDistrictData) {
    permanentAddress += " - ";
    permanentAddress += value.permanentAddressDistrictData?.name;
  }
  if (value?.permanentAddressProvinceData) {
    permanentAddress += " - ";
    permanentAddress += value.permanentAddressProvinceData?.name;
  }

  let currentAddress = value?.currentAddress || "";
  if (value?.currentAddressWardData) {
    currentAddress += ", ";
    currentAddress += value.currentAddressWardData?.name;
  }
  if (value?.currentAddressDistrictData) {
    currentAddress += " - ";
    currentAddress += value.currentAddressDistrictData?.name;
  }
  if (value?.currentAddressProvinceData) {
    currentAddress += " - ";
    currentAddress += value.currentAddressProvinceData?.name;
  }

  let permanentAddressOld = value?.permanentAddressOld || "";
  if (value?.permanentAddressWardDataOld) {
    permanentAddressOld += ", ";
    permanentAddressOld += value.permanentAddressWardDataOld?.name;
  }
  if (value?.permanentAddressDistrictDataOld) {
    permanentAddressOld += " - ";
    permanentAddressOld += value.permanentAddressDistrictDataOld?.name;
  }
  if (value?.permanentAddressProvinceDataOld) {
    permanentAddressOld += " - ";
    permanentAddressOld += value.permanentAddressProvinceDataOld?.name;
  }

  let currentAddressOld = value?.currentAddressOld || "";
  if (value?.currentAddressWardDataOld) {
    currentAddressOld += ", ";
    currentAddressOld += value.currentAddressWardDataOld?.name;
  }
  if (value?.currentAddressDistrictDataOld) {
    currentAddressOld += " - ";
    currentAddressOld += value.currentAddressDistrictDataOld?.name;
  }
  if (value?.currentAddressProvinceDataOld) {
    currentAddressOld += " - ";
    currentAddressOld += value.currentAddressProvinceDataOld?.name;
  }

  const submitStatus = async (status) => {
    const toastEdit = toast.loading("Đang cập nhập trạng thái ...");
    const dataFormat = {
      status: status,
    };

    try {
      await customerUpdateRequestCall.approve(value?.id, dataFormat);
      refetch();
      onClose();
      toast.success("Cập nhập trạng thái thành công");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Có lỗi xảy ra khi cập nhập trạng thái");
    }
    toast.dismiss(toastEdit);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        backgroundColor="var(--color-main)"
        borderRadius={"16px"}
        position={"relative"}
        w={"100%"}
        maxW={"1025px"}
        h={"max-content"}
      >
        <Flex
          alignItems={"center"}
          p={"25px 24px 24px 24px"}
          position={"relative"}
          borderBottom={"1px solid var(--border-input-employee)"}
        >
          <Text
            color={"var(--color-header-employee)"}
            fontSize={"16px"}
            fontWeight={"600"}
          >
            Chi tiết phiếu chỉnh sửa khách hàng
          </Text>
          <Box
            position={"absolute"}
            top={"24px"}
            right={"24px"}
            cursor={"pointer"}
            onClick={onClose}
          >
            <Image src={IconX} />
          </Box>
        </Flex>

        {(value?.status === "APPROVED" || value?.status === "REJECTED") && (
          <Flex
            p={"16px 24px"}
            justifyContent={"space-between"}
            bg={
              value?.status === "APPROVED"
                ? "var(--bg-green-1)"
                : "var(--bg-red-1)"
            }
          >
            {value?.status === "APPROVED" && (
              <Flex
                p={"12px"}
                justifyContent={"space-between"}
                gap={"8px"}
                bg={"var(--bg-status-success)"}
                borderRadius={"8px"}
                w={"max-content"}
                minW={"151px"}
                h={"max-content"}
              >
                <Image
                  src={IconCheck}
                  w={"20px"}
                  h={"20px"}
                  objectFit={"cover"}
                />
                <Text
                  fontSize={"14px"}
                  lineHeight={"20px"}
                  fontWeight={500}
                  color={"var(--color-status-employ)"}
                  display={"block"}
                >
                  Đã được duyệt
                </Text>
              </Flex>
            )}
            {value?.status === "REJECTED" && (
              <Flex
                p={"12px"}
                justifyContent={"space-between"}
                gap={"8px"}
                bg={"var(--bg-status-error)"}
                borderRadius={"8px"}
                w={"max-content"}
                minW={"176px"}
                h={"max-content"}
              >
                <Image
                  src={IconRed}
                  w={"20px"}
                  h={"20px"}
                  objectFit={"cover"}
                />
                <Text
                  fontSize={"14px"}
                  lineHeight={"20px"}
                  fontWeight={500}
                  color={"var(--text-red-employee)"}
                  display={"block"}
                >
                  Không được duyệt
                </Text>
              </Flex>
            )}

            <Flex gap={"40px"}>
              <Box textAlign={"end"}>
                <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                  Người phê duyệt
                </Text>
                <Text
                  color={"var(--color-option-employee)"}
                  fontSize={"14px"}
                  fontWeight={"500"}
                  mt={"8px"}
                >
                  {value?.approver?.fullName}
                </Text>
              </Box>
            </Flex>
          </Flex>
        )}

        <Flex>
          <Box flex={1} p={"24px"}>
            <Box>
              <Text
                color={"var(--color-header-employee)"}
                fontSize={"16px"}
                fontWeight={"600"}
              >
                Dữ liệu cũ
              </Text>
            </Box>
            <Box mt={"24px"}>
              <Text
                color={"var(--color-header-employee)"}
                fontSize={"16px"}
                fontWeight={"600"}
              >
                Loại khách hàng:{" "}
                {!value?.isBusinessOld
                  ? "Khách hàng cá nhân"
                  : "Khách hàng doanh nghiệp"}
              </Text>
            </Box>
            <Box mt={"24px"}>
              <Text
                color={"var(--color-header-employee)"}
                fontSize={"16px"}
                fontWeight={"600"}
              >
                Thông tin khách hàng cá nhân
              </Text>
              <Box flex={1}>
                <Box>
                  <Box margin={"0 auto"}>
                    <Flex>
                      <Box flex={1}>
                        <Box>
                          <Box
                            background={"var(--fill-avatar)"}
                            p={"16px 24px 16px 16px"}
                            mt={"13px"}
                            borderRadius={"8px"}
                          >
                            <Flex gap={"27px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Họ và tên
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {!value?.isBusinessOld
                                    ? value?.nameOld || "-"
                                    : "-"}
                                </Text>
                              </Box>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Công việc
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.jobOld || "-"}
                                </Text>
                              </Box>
                            </Flex>
                            <Flex gap={"27px"} mt={"16px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Số điện thoại
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {!value?.isBusinessOld
                                    ? value?.phoneOld || "-"
                                    : "-"}
                                </Text>
                              </Box>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Email
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {!value?.isBusinessOld
                                    ? value?.emailOld || "-"
                                    : "-"}
                                </Text>
                              </Box>
                            </Flex>

                            <Flex gap={"27px"} mt={"16px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Giới tính
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {!value?.isBusinessOld
                                    ? value?.genderOld || "-"
                                    : "-"}
                                </Text>
                              </Box>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Ngày sinh
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {!value?.isBusinessOld
                                    ? value?.dateOfBirthOld || "-"
                                    : "-"}
                                </Text>
                              </Box>
                            </Flex>
                            <Flex gap={"27px"} mt={"16px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Loại giấy tờ tuỳ thân
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.identityNumberOld || "-"}
                                </Text>
                              </Box>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Số CCCD
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.identificationNumberOld || "-"}
                                </Text>
                              </Box>
                            </Flex>
                            <Flex gap={"27px"} mt={"16px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Ngày cấp
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.dateOfIdentificationOld || "-"}
                                </Text>
                              </Box>
                            </Flex>
                            <Flex mt={"16px"} gap={"27px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Nơi cấp
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.placeOfIdentificationOld || "-"}
                                </Text>
                              </Box>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Địa chỉ thường trú
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {permanentAddressOld || "-"}
                                </Text>
                              </Box>
                            </Flex>
                            <Flex mt={"16px"} gap={"27px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Chỗ ở hiện tại
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {currentAddressOld || "-"}
                                </Text>
                              </Box>
                            </Flex>

                            <Box flex={"1"} mt={4}>
                              <Text
                                color={"var(--color-label-employee)"}
                                fontSize={"12px"}
                              >
                                Ảnh CCCD mặt trước
                              </Text>
                              <Flex
                                mt={"8px"}
                                border={"0.5px solid var(--bg-line-employee)"}
                                borderRadius={"8px"}
                                justifyContent={"center"}
                              >
                                <Box
                                  borderRadius={"11px"}
                                  w={"202px"}
                                  h={"300px"}
                                >
                                  {value?.idCardFrontImageOld && (
                                    // <Image
                                    //   borderRadius={"11px"}
                                    //   w={"100%"}
                                    //   h={"100%"}
                                    //   objectFit={"cover"}
                                    //   src={`${baseURL}/${value.idCardFrontImageOld}`}
                                    // />
                                    <ImagePreviewZoom
                                      src={`${baseURL}/${value.idCardFrontImageOld}`}
                                      alt={`Ảnh CCCD mặt trước`}
                                      previewTitle={`Ảnh CCCD mặt trước`}
                                    >
                                      <Image
                                        borderRadius={"11px"}
                                        w={"100%"}
                                        h={"100%"}
                                        objectFit={"cover"}
                                        src={`${baseURL}/${value.idCardFrontImageOld}`}
                                      />
                                    </ImagePreviewZoom>
                                  )}
                                </Box>
                              </Flex>
                            </Box>

                            <Box flex={"1"} mt={4}>
                              <Text
                                color={"var(--color-label-employee)"}
                                fontSize={"12px"}
                              >
                                Ảnh CCCD mặt sau
                              </Text>
                              <Flex
                                mt={"8px"}
                                border={"0.5px solid var(--bg-line-employee)"}
                                borderRadius={"8px"}
                                justifyContent={"center"}
                              >
                                <Box
                                  borderRadius={"11px"}
                                  w={"202px"}
                                  h={"300px"}
                                >
                                  {value?.idCardBackImageOld && (
                                    // <Image
                                    //   borderRadius={"11px"}
                                    //   w={"100%"}
                                    //   h={"100%"}
                                    //   objectFit={"cover"}
                                    //   src={`${baseURL}/${value.idCardBackImageOld}`}
                                    // />
                                    <ImagePreviewZoom
                                      src={`${baseURL}/${value.idCardBackImageOld}`}
                                      alt={`Ảnh CCCD mặt sau`}
                                      previewTitle={`Ảnh CCCD mặt sau`}
                                    >
                                      <Image
                                        borderRadius={"11px"}
                                        w={"100%"}
                                        h={"100%"}
                                        objectFit={"cover"}
                                        src={`${baseURL}/${value.idCardBackImageOld}`}
                                      />
                                    </ImagePreviewZoom>
                                  )}
                                </Box>
                              </Flex>
                            </Box>

                            <Box flex={"1"} mt={4}>
                              <Text
                                color={"var(--color-label-employee)"}
                                fontSize={"12px"}
                              >
                                Ảnh VNID
                              </Text>
                              <Flex
                                mt={"8px"}
                                border={"0.5px solid var(--bg-line-employee)"}
                                borderRadius={"8px"}
                                justifyContent={"center"}
                              >
                                <Box
                                  borderRadius={"11px"}
                                  w={"202px"}
                                  h={"300px"}
                                >
                                  {value?.vnidImageOld && (
                                    // <Image
                                    //   borderRadius={"11px"}
                                    //   w={"100%"}
                                    //   h={"100%"}
                                    //   objectFit={"cover"}
                                    //   src={`${baseURL}/${value.vnidImageOld}`}
                                    // />
                                    <ImagePreviewZoom
                                      src={`${baseURL}/${value.vnidImageOld}`}
                                      alt={`Ảnh VNID`}
                                      previewTitle={`Ảnh VNID`}
                                    >
                                      <Image
                                        borderRadius={"11px"}
                                        w={"100%"}
                                        h={"100%"}
                                        objectFit={"cover"}
                                        src={`${baseURL}/${value.vnidImageOld}`}
                                      />
                                    </ImagePreviewZoom>
                                  )}
                                </Box>
                              </Flex>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Flex>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box mt={"24px"}>
              <Text
                color={"var(--color-header-employee)"}
                fontSize={"16px"}
                fontWeight={"600"}
              >
                Thông tin khách hàng doanh nghiệp
              </Text>
              <Box flex={1}>
                <Box>
                  <Box margin={"0 auto"}>
                    <Flex>
                      <Box flex={1}>
                        {/*  */}
                        <Box>
                          <Box
                            background={"var(--fill-avatar)"}
                            p={"16px 24px 16px 16px"}
                            mt={"13px"}
                            borderRadius={"8px"}
                          >
                            <Flex gap={"27px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Tên doanh nghiệp
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.isBusinessOld
                                    ? value?.nameOld || "-"
                                    : "-"}
                                </Text>
                              </Box>
                            </Flex>
                            <Flex gap={"27px"} mt={"16px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Số điện thoại
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.isBusinessOld
                                    ? value?.phoneOld || "-"
                                    : "-"}
                                </Text>
                              </Box>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Email
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.isBusinessOld
                                    ? value?.emailOld || "-"
                                    : "-"}
                                </Text>
                              </Box>
                            </Flex>

                            <Flex gap={"27px"} mt={"16px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Mã số thuế
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.businessTaxCodeOld || "-"}
                                </Text>
                              </Box>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Ngày cấp đăng ký kinh doanh
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.businessRegistrationDateOld || "-"}
                                </Text>
                              </Box>
                            </Flex>

                            <Flex gap={"27px"} mt={"16px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Địa chỉ trên đăng ký kinh doanh
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.businessAddressOld || "-"}
                                </Text>
                              </Box>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Địa chỉ văn phòng doanh nghiệp
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.businessLocationAddressOld || "-"}
                                </Text>
                              </Box>
                            </Flex>

                            <Flex gap={"27px"} mt={"16px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Nơi cấp đăng ký kinh doanh
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.businessRegistrationPlaceOld || "-"}
                                </Text>
                              </Box>
                            </Flex>

                            <Box>
                              <Flex flexDirection={"column"}>
                                <Box flex={"1"} mt={4}>
                                  <Text
                                    color={"var(--color-label-employee)"}
                                    fontSize={"12px"}
                                  >
                                    Ảnh đăng ký kinh doanh của doanh nghiệp
                                  </Text>

                                  {value?.businessRegistrationImageOld &&
                                  value.businessRegistrationImageOld.length > 0
                                    ? value.businessRegistrationImageOld.map(
                                        (item, index) => (
                                          <Flex
                                            key={index}
                                            mt={"8px"}
                                            border={
                                              "0.5px solid var(--bg-line-employee)"
                                            }
                                            borderRadius={"8px"}
                                            justifyContent={"center"}
                                          >
                                            <Box
                                              borderRadius={"11px"}
                                              w={"202px"}
                                              h={"300px"}
                                            >
                                              {item && (
                                                <Image
                                                  borderRadius={"11px"}
                                                  w={"100%"}
                                                  h={"100%"}
                                                  objectFit={"cover"}
                                                  src={`${baseURL}/${item}`}
                                                />
                                              )}
                                            </Box>
                                          </Flex>
                                        ),
                                      )
                                    : "-"}
                                </Box>
                              </Flex>
                            </Box>

                            {/*  */}
                            <Flex gap={"27px"} mt={"16px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Tên người đại diện
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.representativeNameOld || "-"}
                                </Text>
                              </Box>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Giới tính
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.isBusinessOld
                                    ? value?.genderOld || "-"
                                    : "-"}
                                </Text>
                              </Box>
                            </Flex>
                            <Flex gap={"27px"} mt={"16px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Số CCCD
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.representativeIdNumberOld || "-"}
                                </Text>
                              </Box>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Ngày cấp
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.representativeIdIssuedDateOld || "-"}
                                </Text>
                              </Box>
                            </Flex>
                            <Flex gap={"27px"} mt={"16px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Nơi cấp
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.representativeIdIssuedPlaceOld || "-"}
                                </Text>
                              </Box>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Chức vụ
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.representativePositionOld || "-"}
                                </Text>
                              </Box>
                            </Flex>
                            {/* <Flex gap={"27px"} mt={"16px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Ngày sinh
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.isBusinessOld
                                    ? value?.dateOfBirthOld || "-"
                                    : "-"}
                                </Text>
                              </Box>
                            </Flex> */}

                            <Box flex={"1"} mt={4}>
                              <Text
                                color={"var(--color-label-employee)"}
                                fontSize={"12px"}
                              >
                                Ảnh CCCD mặt trước
                              </Text>
                              <Flex
                                mt={"8px"}
                                border={"0.5px solid var(--bg-line-employee)"}
                                borderRadius={"8px"}
                                justifyContent={"center"}
                              >
                                <Box
                                  borderRadius={"11px"}
                                  w={"202px"}
                                  h={"300px"}
                                >
                                  {value?.idRepresentativeCardFrontImageOld && (
                                    // <Image
                                    //   borderRadius={"11px"}
                                    //   w={"100%"}
                                    //   h={"100%"}
                                    //   objectFit={"cover"}
                                    //   src={`${baseURL}/${value.idRepresentativeCardFrontImageOld}`}
                                    // />
                                    <ImagePreviewZoom
                                      src={`${baseURL}/${value.idRepresentativeCardFrontImageOld}`}
                                      alt={`Ảnh CCCD mặt trước`}
                                      previewTitle={`Ảnh CCCD mặt trước`}
                                    >
                                      <Image
                                        borderRadius={"11px"}
                                        w={"100%"}
                                        h={"100%"}
                                        objectFit={"cover"}
                                        src={`${baseURL}/${value.idRepresentativeCardFrontImageOld}`}
                                      />
                                    </ImagePreviewZoom>
                                  )}
                                </Box>
                              </Flex>
                            </Box>

                            <Box flex={"1"} mt={4}>
                              <Text
                                color={"var(--color-label-employee)"}
                                fontSize={"12px"}
                              >
                                Ảnh CCCD mặt sau
                              </Text>
                              <Flex
                                mt={"8px"}
                                border={"0.5px solid var(--bg-line-employee)"}
                                borderRadius={"8px"}
                                justifyContent={"center"}
                              >
                                <Box
                                  borderRadius={"11px"}
                                  w={"202px"}
                                  h={"300px"}
                                >
                                  {value?.idRepresentativeCardBackImageOld && (
                                    // <Image
                                    //   borderRadius={"11px"}
                                    //   w={"100%"}
                                    //   h={"100%"}
                                    //   objectFit={"cover"}
                                    //   src={`${baseURL}/${value.idRepresentativeCardBackImageOld}`}
                                    // />
                                    <ImagePreviewZoom
                                      src={`${baseURL}/${value.idRepresentativeCardBackImageOld}`}
                                      alt={`Ảnh CCCD mặt sau`}
                                      previewTitle={`Ảnh CCCD mặt sau`}
                                    >
                                      <Image
                                        borderRadius={"11px"}
                                        w={"100%"}
                                        h={"100%"}
                                        objectFit={"cover"}
                                        src={`${baseURL}/${value.idRepresentativeCardBackImageOld}`}
                                      />
                                    </ImagePreviewZoom>
                                  )}
                                </Box>
                              </Flex>
                            </Box>

                            <Box flex={"1"} mt={4}>
                              <Text
                                color={"var(--color-label-employee)"}
                                fontSize={"12px"}
                              >
                                Ảnh VNID
                              </Text>
                              <Flex
                                mt={"8px"}
                                border={"0.5px solid var(--bg-line-employee)"}
                                borderRadius={"8px"}
                                justifyContent={"center"}
                              >
                                <Box
                                  borderRadius={"11px"}
                                  w={"202px"}
                                  h={"300px"}
                                >
                                  {value?.representativeVnidImageOld && (
                                    // <Image
                                    //   borderRadius={"11px"}
                                    //   w={"100%"}
                                    //   h={"100%"}
                                    //   objectFit={"cover"}
                                    //   src={`${baseURL}/${value.representativeVnidImageOld}`}
                                    // />
                                    <ImagePreviewZoom
                                      src={`${baseURL}/${value.representativeVnidImageOld}`}
                                      alt={`Ảnh VNID`}
                                      previewTitle={`Ảnh VNID`}
                                    >
                                      <Image
                                        borderRadius={"11px"}
                                        w={"100%"}
                                        h={"100%"}
                                        objectFit={"cover"}
                                        src={`${baseURL}/${value.representativeVnidImageOld}`}
                                      />
                                    </ImagePreviewZoom>
                                  )}
                                </Box>
                              </Flex>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Flex>
                  </Box>
                </Box>
              </Box>
            </Box>
            {/*  */}
            <Box mt={"24px"}>
              <Text
                color={"var(--color-header-employee)"}
                fontSize={"16px"}
                fontWeight={"600"}
                mb={"16px"}
                mt={"16px"}
              >
                Phân loại
              </Text>
              <Flex
                gap={"27px"}
                background={"var(--fill-avatar)"}
                p={"16px 24px 16px 16px"}
                borderRadius={"8px"}
              >
                <Box flex={"1"}>
                  <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                    Phân loại Khách hàng
                  </Text>
                  <Text
                    color={"var(--color-option-employee)"}
                    fontSize={"14px"}
                    fontWeight={"500"}
                    mt={"8px"}
                  >
                    {value?.customerTypeOld || "-"}
                  </Text>
                </Box>
                {projectNameOld && projectNameOld?.length > 0 && (
                  <Box flex={"1"}>
                    <Text
                      color={"var(--color-label-employee)"}
                      fontSize={"12px"}
                    >
                      Dự án quan tâm
                    </Text>
                    <Text
                      color={"var(--color-option-employee)"}
                      fontSize={"14px"}
                      fontWeight={"500"}
                      mt={"8px"}
                    >
                      {projectNameOld.join(", ")}
                    </Text>
                  </Box>
                )}
              </Flex>
            </Box>

            {/*  */}
            <Box>
              <Text
                color={"var(--color-header-employee)"}
                fontSize={"16px"}
                fontWeight={"600"}
                mb={"16px"}
                mt={"16px"}
              >
                Thông tin thanh toán
              </Text>
              <Box
                background={"var(--fill-avatar)"}
                p={"16px 24px 16px 16px"}
                borderRadius={"8px"}
              >
                <Flex gap={"27px"}>
                  <Box flex={"1"}>
                    <Text
                      color={"var(--color-label-employee)"}
                      fontSize={"12px"}
                    >
                      Số tài khoản
                    </Text>
                    <Text
                      color={"var(--color-option-employee)"}
                      fontSize={"14px"}
                      fontWeight={"500"}
                      mt={"8px"}
                    >
                      {value?.bankAccountOld || "-"}
                    </Text>
                  </Box>
                  <Box flex={"1"}>
                    <Text
                      color={"var(--color-label-employee)"}
                      fontSize={"12px"}
                    >
                      Tên ngân hàng
                    </Text>
                    <Text
                      color={"var(--color-option-employee)"}
                      fontSize={"14px"}
                      fontWeight={"500"}
                      mt={"8px"}
                    >
                      {value?.bankNameOld || "-"}
                    </Text>
                  </Box>
                </Flex>
                <Flex gap={"27px"} mt={"16px"}>
                  <Box flex={"1"}>
                    <Text
                      color={"var(--color-label-employee)"}
                      fontSize={"12px"}
                    >
                      Chủ tài khoản ngân hàng
                    </Text>
                    <Text
                      color={"var(--color-option-employee)"}
                      fontSize={"14px"}
                      fontWeight={"500"}
                      mt={"8px"}
                    >
                      {value?.nameAccountOld || "-"}
                    </Text>
                  </Box>
                </Flex>
              </Box>
            </Box>
          </Box>
          <Box flex={1} p={"24px"}>
            <Box>
              <Text
                color={"var(--color-header-employee)"}
                fontSize={"16px"}
                fontWeight={"600"}
              >
                Dữ liệu mới
              </Text>
            </Box>
            <Box mt={"24px"}>
              <Text
                color={"var(--color-header-employee)"}
                fontSize={"16px"}
                fontWeight={"600"}
              >
                Loại khách hàng:{" "}
                {!value?.isBusiness
                  ? "Khách hàng cá nhân"
                  : "Khách hàng doanh nghiệp"}
              </Text>
            </Box>
            <Box mt={"24px"}>
              <Text
                color={"var(--color-header-employee)"}
                fontSize={"16px"}
                fontWeight={"600"}
              >
                Thông tin khách hàng cá nhân
              </Text>
              <Box flex={1}>
                <Box>
                  <Box margin={"0 auto"}>
                    <Flex>
                      <Box flex={1}>
                        <Box>
                          <Box
                            background={"var(--fill-avatar)"}
                            p={"16px 24px 16px 16px"}
                            mt={"13px"}
                            borderRadius={"8px"}
                          >
                            <Flex gap={"27px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Họ và tên
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {!value?.isBusiness
                                    ? value?.name || "-"
                                    : "-"}
                                </Text>
                              </Box>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Công việc
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.job || "-"}
                                </Text>
                              </Box>
                            </Flex>
                            <Flex gap={"27px"} mt={"16px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Số điện thoại
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {!value?.isBusiness
                                    ? value?.phone || "-"
                                    : "-"}
                                </Text>
                              </Box>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Email
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {!value?.isBusiness
                                    ? value?.email || "-"
                                    : "-"}
                                </Text>
                              </Box>
                            </Flex>

                            <Flex gap={"27px"} mt={"16px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Giới tính
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {!value?.isBusiness
                                    ? value?.gender || "-"
                                    : "-"}
                                </Text>
                              </Box>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Ngày sinh
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {!value?.isBusiness
                                    ? value?.dateOfBirth || "-"
                                    : "-"}
                                </Text>
                              </Box>
                            </Flex>
                            <Flex gap={"27px"} mt={"16px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Loại giấy tờ tuỳ thân
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.identityNumber || "-"}
                                </Text>
                              </Box>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Số CCCD
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.identificationNumber || "-"}
                                </Text>
                              </Box>
                            </Flex>
                            <Flex gap={"27px"} mt={"16px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Ngày cấp
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.dateOfIdentification || "-"}
                                </Text>
                              </Box>
                            </Flex>
                            <Flex mt={"16px"} gap={"27px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Nơi cấp
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.placeOfIdentification || "-"}
                                </Text>
                              </Box>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Địa chỉ thường trú
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {permanentAddress || "-"}
                                </Text>
                              </Box>
                            </Flex>
                            <Flex mt={"16px"} gap={"27px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Chỗ ở hiện tại
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {currentAddress || "-"}
                                </Text>
                              </Box>
                            </Flex>

                            <Box flex={"1"} mt={4}>
                              <Text
                                color={"var(--color-label-employee)"}
                                fontSize={"12px"}
                              >
                                Ảnh CCCD mặt trước
                              </Text>
                              <Flex
                                mt={"8px"}
                                border={"0.5px solid var(--bg-line-employee)"}
                                borderRadius={"8px"}
                                justifyContent={"center"}
                              >
                                <Box
                                  borderRadius={"11px"}
                                  w={"202px"}
                                  h={"300px"}
                                >
                                  {value?.idCardFrontImage && (
                                    // <Image
                                    //   borderRadius={"11px"}
                                    //   w={"100%"}
                                    //   h={"100%"}
                                    //   objectFit={"cover"}
                                    //   src={`${baseURL}/${value.idCardFrontImage}`}
                                    // />
                                    <ImagePreviewZoom
                                      src={`${baseURL}/${value.idCardFrontImage}`}
                                      alt={`Ảnh CCCD mặt trước`}
                                      previewTitle={`Ảnh CCCD mặt trước`}
                                    >
                                      <Image
                                        borderRadius={"11px"}
                                        w={"100%"}
                                        h={"100%"}
                                        objectFit={"cover"}
                                        src={`${baseURL}/${value.idCardFrontImage}`}
                                      />
                                    </ImagePreviewZoom>
                                  )}
                                </Box>
                              </Flex>
                            </Box>

                            <Box flex={"1"} mt={4}>
                              <Text
                                color={"var(--color-label-employee)"}
                                fontSize={"12px"}
                              >
                                Ảnh CCCD mặt sau
                              </Text>
                              <Flex
                                mt={"8px"}
                                border={"0.5px solid var(--bg-line-employee)"}
                                borderRadius={"8px"}
                                justifyContent={"center"}
                              >
                                <Box
                                  borderRadius={"11px"}
                                  w={"202px"}
                                  h={"300px"}
                                >
                                  {value?.idCardBackImage && (
                                    // <Image
                                    //   borderRadius={"11px"}
                                    //   w={"100%"}
                                    //   h={"100%"}
                                    //   objectFit={"cover"}
                                    //   src={`${baseURL}/${value.idCardBackImage}`}
                                    // />
                                    <ImagePreviewZoom
                                      src={`${baseURL}/${value.idCardBackImage}`}
                                      alt={`Ảnh CCCD mặt sau`}
                                      previewTitle={`Ảnh CCCD mặt sau`}
                                    >
                                      <Image
                                        borderRadius={"11px"}
                                        w={"100%"}
                                        h={"100%"}
                                        objectFit={"cover"}
                                        src={`${baseURL}/${value.idCardBackImage}`}
                                      />
                                    </ImagePreviewZoom>
                                  )}
                                </Box>
                              </Flex>
                            </Box>

                            <Box flex={"1"} mt={4}>
                              <Text
                                color={"var(--color-label-employee)"}
                                fontSize={"12px"}
                              >
                                Ảnh VNID
                              </Text>
                              <Flex
                                mt={"8px"}
                                border={"0.5px solid var(--bg-line-employee)"}
                                borderRadius={"8px"}
                                justifyContent={"center"}
                              >
                                <Box
                                  borderRadius={"11px"}
                                  w={"202px"}
                                  h={"300px"}
                                >
                                  {value?.vnidImage && (
                                    // <Image
                                    //   borderRadius={"11px"}
                                    //   w={"100%"}
                                    //   h={"100%"}
                                    //   objectFit={"cover"}
                                    //   src={`${baseURL}/${value.vnidImage}`}
                                    // />
                                    <ImagePreviewZoom
                                      src={`${baseURL}/${value.vnidImage}`}
                                      alt={`Ảnh VNID`}
                                      previewTitle={`Ảnh VNID`}
                                    >
                                      <Image
                                        borderRadius={"11px"}
                                        w={"100%"}
                                        h={"100%"}
                                        objectFit={"cover"}
                                        src={`${baseURL}/${value.vnidImage}`}
                                      />
                                    </ImagePreviewZoom>
                                  )}
                                </Box>
                              </Flex>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Flex>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box mt={"24px"}>
              <Text
                color={"var(--color-header-employee)"}
                fontSize={"16px"}
                fontWeight={"600"}
              >
                Thông tin khách hàng doanh nghiệp
              </Text>
              <Box flex={1}>
                <Box>
                  <Box margin={"0 auto"}>
                    <Flex>
                      <Box flex={1}>
                        {/*  */}
                        <Box>
                          <Box
                            background={"var(--fill-avatar)"}
                            p={"16px 24px 16px 16px"}
                            mt={"13px"}
                            borderRadius={"8px"}
                          >
                            <Flex gap={"27px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Tên doanh nghiệp
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.isBusiness ? value?.name || "-" : "-"}
                                </Text>
                              </Box>
                            </Flex>
                            <Flex gap={"27px"} mt={"16px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Số điện thoại
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.isBusiness
                                    ? value?.phone || "-"
                                    : "-"}
                                </Text>
                              </Box>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Email
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.isBusiness
                                    ? value?.email || "-"
                                    : "-"}
                                </Text>
                              </Box>
                            </Flex>

                            <Flex gap={"27px"} mt={"16px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Mã số thuế
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.businessTaxCode || "-"}
                                </Text>
                              </Box>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Ngày cấp đăng ký kinh doanh
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.businessRegistrationDate || "-"}
                                </Text>
                              </Box>
                            </Flex>

                            <Flex gap={"27px"} mt={"16px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Địa chỉ trên đăng ký kinh doanh
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.businessAddress || "-"}
                                </Text>
                              </Box>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Địa chỉ văn phòng doanh nghiệp
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.businessLocationAddress || "-"}
                                </Text>
                              </Box>
                            </Flex>

                            <Flex gap={"27px"} mt={"16px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Nơi cấp đăng ký kinh doanh
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.businessRegistrationPlace || "-"}
                                </Text>
                              </Box>
                            </Flex>

                            <Box>
                              <Flex flexDirection={"column"}>
                                <Box flex={"1"} mt={4}>
                                  <Text
                                    color={"var(--color-label-employee)"}
                                    fontSize={"12px"}
                                  >
                                    Ảnh đăng ký kinh doanh của doanh nghiệp
                                  </Text>

                                  {value?.businessRegistrationImage &&
                                  value.businessRegistrationImage.length > 0
                                    ? value.businessRegistrationImage.map(
                                        (item, index) => (
                                          <Flex
                                            key={index}
                                            mt={"8px"}
                                            border={
                                              "0.5px solid var(--bg-line-employee)"
                                            }
                                            borderRadius={"8px"}
                                            justifyContent={"center"}
                                          >
                                            <Box
                                              borderRadius={"11px"}
                                              w={"202px"}
                                              h={"300px"}
                                            >
                                              {item && (
                                                <Image
                                                  borderRadius={"11px"}
                                                  w={"100%"}
                                                  h={"100%"}
                                                  objectFit={"cover"}
                                                  src={`${baseURL}/${item}`}
                                                />
                                              )}
                                            </Box>
                                          </Flex>
                                        ),
                                      )
                                    : "-"}
                                </Box>
                              </Flex>
                            </Box>

                            {/*  */}
                            <Flex gap={"27px"} mt={"16px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Tên người đại diện
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.representativeName || "-"}
                                </Text>
                              </Box>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Giới tính
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.isBusiness
                                    ? value?.gender || "-"
                                    : "-"}
                                </Text>
                              </Box>
                            </Flex>
                            <Flex gap={"27px"} mt={"16px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Số CCCD
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.representativeIdNumber || "-"}
                                </Text>
                              </Box>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Ngày cấp
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.representativeIdIssuedDate || "-"}
                                </Text>
                              </Box>
                            </Flex>
                            <Flex gap={"27px"} mt={"16px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Nơi cấp
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.representativeIdIssuedPlace || "-"}
                                </Text>
                              </Box>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Chức vụ
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {value?.representativePosition || "-"}
                                </Text>
                              </Box>
                            </Flex>
                            {/* <Flex gap={"27px"} mt={"16px"}>
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Ngày sinh
                                </Text>
                                <Text
                                  color={"var(--color-option-employee)"}
                                  fontSize={"14px"}
                                  fontWeight={"500"}
                                  mt={"8px"}
                                >
                                  {!value?.isBusinessOld
                                    ? value?.dateOfBirthOld || "-"
                                    : "-"}
                                </Text>
                              </Box>
                            </Flex> */}
                            <Box flex={"1"} mt={4}>
                              <Text
                                color={"var(--color-label-employee)"}
                                fontSize={"12px"}
                              >
                                Ảnh CCCD mặt trước
                              </Text>
                              <Flex
                                mt={"8px"}
                                border={"0.5px solid var(--bg-line-employee)"}
                                borderRadius={"8px"}
                                justifyContent={"center"}
                              >
                                <Box
                                  borderRadius={"11px"}
                                  w={"202px"}
                                  h={"300px"}
                                >
                                  {value?.idRepresentativeCardFrontImage && (
                                    // <Image
                                    //   borderRadius={"11px"}
                                    //   w={"100%"}
                                    //   h={"100%"}
                                    //   objectFit={"cover"}
                                    //   src={`${baseURL}/${value.idRepresentativeCardFrontImage}`}
                                    // />
                                    <ImagePreviewZoom
                                      src={`${baseURL}/${value.idRepresentativeCardFrontImage}`}
                                      alt={`Ảnh CCCD mặt trước`}
                                      previewTitle={`Ảnh CCCD mặt trước`}
                                    >
                                      <Image
                                        borderRadius={"11px"}
                                        w={"100%"}
                                        h={"100%"}
                                        objectFit={"cover"}
                                        src={`${baseURL}/${value.idRepresentativeCardFrontImage}`}
                                      />
                                    </ImagePreviewZoom>
                                  )}
                                </Box>
                              </Flex>
                            </Box>

                            <Box flex={"1"} mt={4}>
                              <Text
                                color={"var(--color-label-employee)"}
                                fontSize={"12px"}
                              >
                                Ảnh CCCD mặt sau
                              </Text>
                              <Flex
                                mt={"8px"}
                                border={"0.5px solid var(--bg-line-employee)"}
                                borderRadius={"8px"}
                                justifyContent={"center"}
                              >
                                <Box
                                  borderRadius={"11px"}
                                  w={"202px"}
                                  h={"300px"}
                                >
                                  {value?.idRepresentativeCardBackImage && (
                                    // <Image
                                    //   borderRadius={"11px"}
                                    //   w={"100%"}
                                    //   h={"100%"}
                                    //   objectFit={"cover"}
                                    //   src={`${baseURL}/${value.idRepresentativeCardBackImage}`}
                                    // />
                                    <ImagePreviewZoom
                                      src={`${baseURL}/${value.idRepresentativeCardBackImage}`}
                                      alt={`Ảnh CCCD mặt sau`}
                                      previewTitle={`Ảnh CCCD mặt sau`}
                                    >
                                      <Image
                                        borderRadius={"11px"}
                                        w={"100%"}
                                        h={"100%"}
                                        objectFit={"cover"}
                                        src={`${baseURL}/${value.idRepresentativeCardBackImage}`}
                                      />
                                    </ImagePreviewZoom>
                                  )}
                                </Box>
                              </Flex>
                            </Box>

                            <Box flex={"1"} mt={4}>
                              <Text
                                color={"var(--color-label-employee)"}
                                fontSize={"12px"}
                              >
                                Ảnh VNID
                              </Text>
                              <Flex
                                mt={"8px"}
                                border={"0.5px solid var(--bg-line-employee)"}
                                borderRadius={"8px"}
                                justifyContent={"center"}
                              >
                                <Box
                                  borderRadius={"11px"}
                                  w={"202px"}
                                  h={"300px"}
                                >
                                  {value?.representativeVnidImage && (
                                    // <Image
                                    //   borderRadius={"11px"}
                                    //   w={"100%"}
                                    //   h={"100%"}
                                    //   objectFit={"cover"}
                                    //   src={`${baseURL}/${value.representativeVnidImage}`}
                                    // />
                                    <ImagePreviewZoom
                                      src={`${baseURL}/${value.representativeVnidImage}`}
                                      alt={`Ảnh VNID`}
                                      previewTitle={`Ảnh VNID`}
                                    >
                                      <Image
                                        borderRadius={"11px"}
                                        w={"100%"}
                                        h={"100%"}
                                        objectFit={"cover"}
                                        src={`${baseURL}/${value.representativeVnidImage}`}
                                      />
                                    </ImagePreviewZoom>
                                  )}
                                </Box>
                              </Flex>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Flex>
                  </Box>
                </Box>
              </Box>
            </Box>
            {/*  */}
            <Box mt={"24px"}>
              {/*  */}
              <Text
                color={"var(--color-header-employee)"}
                fontSize={"16px"}
                fontWeight={"600"}
                mt={"16px"}
                mb={"16px"}
              >
                Phân loại
              </Text>
              <Flex
                gap={"27px"}
                background={"var(--fill-avatar)"}
                p={"16px 24px 16px 16px"}
                borderRadius={"8px"}
              >
                <Box flex={"1"}>
                  <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                    Phân loại Khách hàng
                  </Text>
                  <Text
                    color={"var(--color-option-employee)"}
                    fontSize={"14px"}
                    fontWeight={"500"}
                    mt={"8px"}
                  >
                    {value?.customerType || "-"}
                  </Text>
                </Box>
                {projectName && projectName?.length > 0 && (
                  <Box flex={"1"}>
                    <Text
                      color={"var(--color-label-employee)"}
                      fontSize={"12px"}
                    >
                      Dự án quan tâm
                    </Text>
                    <Box mt="8px">
                      {projectName.map((item, index) => (
                        <Text
                          key={index}
                          color={"var(--color-option-employee)"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                        >
                          {item}
                          {index < item.length ? "," : ""}
                        </Text>
                      ))}
                    </Box>
                  </Box>
                )}
              </Flex>
            </Box>

            {/*  */}
            <Box>
              <Text
                color={"var(--color-header-employee)"}
                fontSize={"16px"}
                fontWeight={"600"}
                mt={"16px"}
                mb={"16px"}
              >
                Thông tin thanh toán
              </Text>
              <Box
                background={"var(--fill-avatar)"}
                p={"16px 24px 16px 16px"}
                borderRadius={"8px"}
              >
                <Flex gap={"27px"}>
                  <Box flex={"1"}>
                    <Text
                      color={"var(--color-label-employee)"}
                      fontSize={"12px"}
                    >
                      Số tài khoản
                    </Text>
                    <Text
                      color={"var(--color-option-employee)"}
                      fontSize={"14px"}
                      fontWeight={"500"}
                      mt={"8px"}
                    >
                      {value?.bankAccount || "-"}
                    </Text>
                  </Box>
                  <Box flex={"1"}>
                    <Text
                      color={"var(--color-label-employee)"}
                      fontSize={"12px"}
                    >
                      Tên ngân hàng
                    </Text>
                    <Text
                      color={"var(--color-option-employee)"}
                      fontSize={"14px"}
                      fontWeight={"500"}
                      mt={"8px"}
                    >
                      {value?.bankName || "-"}
                    </Text>
                  </Box>
                </Flex>
                <Flex gap={"27px"} mt={"16px"}>
                  <Box flex={"1"}>
                    <Text
                      color={"var(--color-label-employee)"}
                      fontSize={"12px"}
                    >
                      Chủ tài khoản ngân hàng
                    </Text>
                    <Text
                      color={"var(--color-option-employee)"}
                      fontSize={"14px"}
                      fontWeight={"500"}
                      mt={"8px"}
                    >
                      {value?.nameAccount || "-"}
                    </Text>
                  </Box>
                </Flex>
              </Box>
            </Box>
          </Box>
        </Flex>
        <Box
          // position={"absolute"}
          w={"100%"}
          bottom={"0"}
          bg={"var(--color-main)"}
          borderTop={"0.5px solid var(--bg-line-employee)"}
          borderRadius={"0px 0px 16px 16px"}
          zIndex={3}
        >
          {(value?.status === "PENDING" || value?.status === "EDITING") && (
            <Flex p={"24px"} gap={"16px"} justifyContent={"flex-end"}>
              <Button
                p={"13px 20px"}
                fontSize={"15px"}
                fontWeight={600}
                color={"var(--color-option-employee-hover)"}
                borderRadius={"8px"}
                border={"1px solid var(--color-option-employee-hover)"}
                bg={"var(--color-main)"}
                onClick={() => submitStatus("REJECTED")}
                _hover={{
                  filter: "brightness(90%)",
                }}
              >
                Không duyệt
              </Button>
              <Button
                w={"133px"}
                p={"13px 20px"}
                fontSize={"15px"}
                fontWeight={600}
                color={"var(--color-main)"}
                borderRadius={"8px"}
                bg={"var(--color-option-employee-hover)"}
                onClick={() => submitStatus("APPROVED")}
                _hover={{
                  filter: "brightness(90%)",
                }}
              >
                Duyệt
              </Button>
            </Flex>
          )}
        </Box>
      </ModalContent>
    </Modal>
  );
});

export default FormInfo;
